import type { StaffNotification } from "../../../api/staffApi";
import { categoryLabel, formatTime } from "../staffFormat";

type NotificationRowProps = {
  item: StaffNotification;
  onRead?: (id: string) => void;
};

export function NotificationRow({ item, onRead }: NotificationRowProps) {
  const unread = !item.readAt;

  return (
    <button
      type="button"
      className={`staff-notification-row${unread ? " staff-notification-row--unread" : ""}`}
      onClick={() => onRead?.(item.id)}
    >
      <div className="staff-notification-row__meta">
        <span className="staff-notification-row__category">{categoryLabel(item.category)}</span>
        <time className="muted" dateTime={item.createdAt}>{formatTime(item.createdAt)}</time>
      </div>
      <p className="staff-notification-row__title">{item.title}</p>
      <p className="staff-notification-row__body muted">{item.body}</p>
    </button>
  );
}
